import { useI18n } from "../contexts/LanguageContext";
import Counter from "../components/Counter";
import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import useSeo from "../hooks/useSeo";

export default function About() {
  const { t } = useI18n();
  useSeo({
    title: "About ENCES Global - 16+ Years of Staffing Excellence",
    description: "Founded in 2009 in Union City, NJ, ENCES Global serves 200+ companies across the Tri-State area, placing 500+ candidates per year with a 95% satisfaction rate.",
    path: "/about",
  });
  return (
    <div data-testid="page-about">
      <section className="bg-navy text-white">
        <div className="container-pad mx-auto max-w-[1400px] py-20">
          <div className="text-xs tracking-[0.3em] uppercase text-white/60 mb-3">{t.nav.about}</div>
          <h1 className="text-4xl md:text-5xl font-extrabold tracking-tight" data-testid="about-title">{t.about.title}</h1>
          <p className="mt-4 text-white/70 text-lg max-w-3xl">{t.about.subtitle}</p>
        </div>
      </section>

      <section className="container-pad mx-auto max-w-[1400px] py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-14">
          {[
            { v: 16, s: "+", label: t.stats.years },
            { v: 500, s: "+", label: t.stats.placements },
            { v: 200, s: "+", label: t.stats.companies },
            { v: 95, s: "%", label: t.stats.satisfaction },
          ].map((x, i) => (
            <div key={i} className="bg-soft rounded-2xl p-6 text-center">
              <div className="text-4xl font-extrabold text-navy"><Counter to={x.v} suffix={x.s} /></div>
              <div className="text-sm text-slate-600 mt-1">{x.label}</div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-start">
          <div>
            <div className="text-xs tracking-[0.3em] uppercase text-brandred mb-3">{t.mission.eyebrow}</div>
            <h2 className="text-3xl font-extrabold text-navy">{t.mission.title}</h2>
            <p className="mt-4 text-slate-600 text-lg leading-relaxed">{t.about.story}</p>
          </div>
          <ul className="space-y-4">
            {t.why.bullets.map((b, i) => (
              <li key={i} className="flex items-start gap-3">
                <span className="mt-1 w-6 h-6 rounded-full bg-green-100 text-green-700 inline-flex items-center justify-center"><Check size={14} /></span>
                <span className="text-slate-700">{b}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="mt-16 rounded-[28px] bg-soft p-10 md:p-12 grid grid-cols-1 md:grid-cols-2 gap-6 items-center">
          <h2 className="text-2xl md:text-3xl font-extrabold text-navy">{t.finalCta.title}</h2>
          <div className="flex flex-col sm:flex-row gap-3 md:justify-end">
            <Link to="/hire" className="inline-flex items-center justify-center gap-2 px-7 py-4 rounded-full bg-brandred hover:bg-red-700 text-white font-semibold">{t.finalCta.business} <ArrowRight size={16} /></Link>
            <Link to="/jobs" className="inline-flex items-center justify-center gap-2 px-7 py-4 rounded-full border-2 border-navy text-navy hover:bg-navy hover:text-white font-semibold transition-colors">{t.finalCta.worker} <ArrowRight size={16} /></Link>
          </div>
        </div>
      </section>
    </div>
  );
}
